"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Router", {
  enumerable: true,
  get: function get() {
    return _Router.default;
  }
});
Object.defineProperty(exports, "routerHistory", {
  enumerable: true,
  get: function get() {
    return _history.default;
  }
});
Object.defineProperty(exports, "routerConnect", {
  enumerable: true,
  get: function get() {
    return _connect.default;
  }
});
Object.defineProperty(exports, "routerMiddleware", {
  enumerable: true,
  get: function get() {
    return _middleware.default;
  }
});
exports.routerActions = void 0;

var _Router = _interopRequireDefault(require("./Router"));

var routerActions = _interopRequireWildcard(require("./actions"));

exports.routerActions = routerActions;

var _history = _interopRequireDefault(require("./history"));

var _connect = _interopRequireDefault(require("./connect"));

var _middleware = _interopRequireDefault(require("./middleware"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}